import hljs from 'highlight.js/lib/core';
import sql from 'highlight.js/lib/languages/sql';
import 'highlight.js/styles/github-dark.css';

hljs.registerLanguage('sql', sql);

export function highlightSql(code) {
    if (!code) return '';
    try {
        return hljs.highlight(code, { language: 'sql', ignoreIllegals: true }).value;
    } catch (e) {
        return escapeHtml(code);
    }
}

function escapeHtml(s) {
    return String(s)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
